import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Layout, Card, notification } from 'antd';
import qs from 'query-string';
import LoginForm from './LoginForm';
import { getAuth } from '../../config';
import SpinnerPage from '../../components/SpinnerPage';
import logoSrc from '../../assets/logo.png';

function LoginPage() {
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const nextIsGoogle =
    location.search &&
    qs.parse(location.search) &&
    qs.parse(location.search).next.includes('authorizeGoogleHome');

  const onSuccess = useCallback(() => {
    if (sessionStorage.getItem('next')) {
      history.replace(sessionStorage.getItem('next'));
    } else if (location.search) {
      const queryString = qs.parse(location.search);
      history.replace(queryString.next);
    } else {
      history.replace('/');
    }
    sessionStorage.removeItem('next');
  }, [history, location]);

  useEffect(() => {
    async function getRedirect() {
      const queryString = qs.parse(location.search);
      window.sessionStorage.setItem('next', queryString.next);

      try {
        const result = await getAuth().getRedirectResult();
        if (result.user) {
          onSuccess();
        }
      } catch (e) {
        notification.error({ message: e.message });
      } finally {
        setLoading(false);
      }
    }

    getRedirect();
  }, []);

  if (loading) {
    return <SpinnerPage />;
  }

  return (
    <Layout style={{ height: '100vh' }}>
      <Layout.Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Card style={{ maxWidth: '40em', margin: 20 }}>
          <img
            src={logoSrc}
            alt="logo"
            style={{ display: 'block', margin: '0 auto 1rem auto', maxWidth: '100%' }}
          />
          {nextIsGoogle && (
            <p style={{ textAlign: 'center' }}>
              Per concedere a Google Home il controllo dei tuoi dispositivi T-Lab esegui
              il login e, subito dopo, verrà visualizzata una schermata di conferma e
              approvazione.
            </p>
          )}
          <LoginForm onSuccess={onSuccess} />
        </Card>
      </Layout.Content>
    </Layout>
  );
}

export default LoginPage;
